<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-epigraph element-with-heading" epub:type="epigraph" id="epigraph-2">
<div class="heading heading-with-title heading-without-image" id="epigraph-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Introduction to Il Gran Cavallo</h1>
</div>
</div>
</div>
</div>
<div class="text" id="epigraph-2-text">
<p class="first first-in-chapter first-full-width"><i>I have no particular artistic ability, but I enjoy art; and I especially enjoy sculpture. All kinds, from classic representational to modern abstracts and more. I can spend hours wandering Frederik Meijer Gardens and Sculpture Park, one of the world’s best sculpture parks right here in West Michigan. And the centerpiece of Meijer Gardens is </i>The American Horse <i>by Nina Akamu, inspired by Da Vinci’s </i>Horse. <i>Frederik Meijer commissioned this 24-foot bronze horse, along with an identical horse for Milan.</i> The American Horse <i>is my muse, my inspiration—and my companion during my recovery from diabetes and an infection that almost killed me.</i></p>
<p class="subsq"><i>So, this story is dedicated to the memory of Frederik Meijer, and to Nina Akamu. Thank you for adding to the beauty of the world.</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introductiontoilgrancavallo.vue?186cdec0